module.exports = __webpack_public_path__ + "static/media/bnr_top.236563db.jpg";